import SweetAlert from './SweetAlert.js'

const Swal = SweetAlert
Swal.default = Swal

export default Swal



//////////////////
// WEBPACK FOOTER
// ./node_modules/sweetalert2/src/sweetalert2.js
// module id = null
// module chunks = 